// Standard table recipe, adapted for the compact player-card modal tables.
//
// The card's chrome (hero, team colors, tabs) is intentionally bespoke, but the
// data tables inside it should read like the rest of the site (user decision
// 2026-06-10): navy uppercase headers, #f0f0f0 row stripes, slate-200 hover.
// These keep the card's tight density (text-[11px] headers, py-1.5 cells) while
// adopting the standard colors.

/** thead row — navy uppercase, bottom rule, no fill. */
export const cardTheadRow =
  'border-b border-slate-200 text-[11px] uppercase tracking-wider text-navy'

/** A data (non-total) body row: zebra stripe + hover. `group` lets the sticky
 *  cell pick up the hover via group-hover. */
export const cardBodyRow = 'group odd:bg-[#f0f0f0] hover:bg-slate-200 text-slate-700'

/** A Career/Total footer-style row inside the body. */
export const cardTotalRow = 'border-t-2 border-slate-300 bg-slate-100 font-bold text-navy'

/** Opaque background for a sticky-left (frozen) cell so it matches its row's
 *  stripe while scrolling. `i` is the row's index in the body (0-based); CSS
 *  :nth-child(odd) stripes indices 0,2,4… → those get #f0f0f0.
 *
 *  The `!` is load-bearing: the frozen cell paints over the row's own
 *  `odd:`/`hover:` background, and without `!important` that row bg can win the
 *  cascade during iOS momentum-scroll and let scrolling columns bleed *through*
 *  the frozen cell (the recurring h-scroll leak — `reference_frozen_columns_seam`).
 *  Matches the DataTable primitive's `!bg-[var(--row-bg)]` frozen-cell paint. */
export function cardStickyBg(i: number): string {
  return `${i % 2 === 0 ? '!bg-[#f0f0f0]' : '!bg-white'} group-hover:!bg-slate-200`
}
